export default __webpack_public_path__ + "static/media/mexican-troll-face-72.76859066.png";